import { createContext } from "react";

export const CommentFilterContext = createContext({
  commentRequested: false, // request opening new comment dialog
  taskUuid: undefined, // set when there is a new standalone draft backing currently edited new comment
  newStandaloneDraft: undefined, // set when there is a new standalone draft backing currently edited new comment
  clientWorkflowUuid: undefined,
  relatedEntityTitle: "",
  relatedEntityType: undefined,
  clearAllFilters: () => {},
  applyFilter: () => {},
  openCommentDialog: () => {},
  fulfillComment: () => {},
  setActiveStandaloneDraft: () => {},
  taskRemoved: () => {},
  taskRenamed: () => {},
  workflowRenamed: () => {},
});

export default CommentFilterContext;
